// extracted by mini-css-extract-plugin
export default {"form":"CancelarPedidoBmaPonto_form__rAQW9","areaBtn":"CancelarPedidoBmaPonto_areaBtn__WkJdL","btn":"CancelarPedidoBmaPonto_btn__gKT3D"};